export type TestIds =
  | 'ImageSlider.prevButton'
  | 'ImageSlider.nextButton'
  | 'ImageSlider.lightboxButton'
  | 'ImageSlider.lightboxContainer'
  | 'ImageSlider.imageSliderContainer'
  | 'ImageSlider.thumbnailContainer'
  | 'ImageSlider.mobileLightbox'
  | 'ImageSlider.copyright'
  | 'Select.error'
  | 'Input.error'
  | 'AmountPicker.decrease'
  | 'AmountPicker.increase'
  | 'AmountPicker.value'
  | 'Breadcrumb.root'
  | 'CalendarHeader.next-months'
  | 'CalendarHeader.previous-months'
  | 'CalendarRoot.root'
  | 'CountrySelect.root'
  | 'DateModalContent.AlternativeDateChip'
  | 'HeaderItem.checked'
  | 'HeaderItem.count'
  | 'InputPassword.error'
  | 'LoginTeaser.link'
  | 'MessageBox.root'
  | 'ModalContent.content'
  | 'Modal.Footer.Actions'
  | 'Modal.Footer.InfoBox'
  | 'Modal.Footer.Button'
  | 'Modal.Header.back'
  | 'Modal.Header.close'
  | 'ToastMessage.root'
  | 'BookingBox.title'
  | 'StickyFooter.root'
  | 'StickyFooter.button'
  | 'BookingBox.message'
  | 'TextField.error'

export const uiTestId = (testId: TestIds) => testId
